import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=ce009afe&scoped=true&"
import script from "./TaskForm.vue?vue&type=script&lang=ts&"
export * from "./TaskForm.vue?vue&type=script&lang=ts&"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=ce009afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce009afe",
  null
  
)

export default component.exports